import { useCallback, useState } from 'react';

export interface CrudListState {
  search: string;
  offset: number;
  limit: number;
  status_filter: 'ACTIVE' | 'INACTIVE' | 'ALL';
}

const DEFAULT_LIMIT = 25;

/**
 * Tiny state hook for paginated catalog screens.
 * Resets `offset` whenever the search term or status filter changes.
 */
export function useCrudList(initial?: Partial<CrudListState>) {
  const [state, setState] = useState<CrudListState>({
    search: initial?.search ?? '',
    offset: initial?.offset ?? 0,
    limit: initial?.limit ?? DEFAULT_LIMIT,
    status_filter: initial?.status_filter ?? 'ACTIVE',
  });

  const setSearch = useCallback((next: string): void => {
    setState((s) => ({ ...s, search: next, offset: 0 }));
  }, []);
  const setOffset = useCallback((next: number): void => {
    setState((s) => ({ ...s, offset: Math.max(0, next) }));
  }, []);
  const setLimit = useCallback((next: number): void => {
    setState((s) => ({ ...s, limit: next, offset: 0 }));
  }, []);
  const setStatusFilter = useCallback((next: CrudListState['status_filter']): void => {
    setState((s) => ({ ...s, status_filter: next, offset: 0 }));
  }, []);

  return { ...state, setSearch, setOffset, setLimit, setStatusFilter };
}
